import React from 'react';

export default (props) => {
  return (
    <React.Fragment>
      <h1 className="page-title">Contacts</h1>

      <p>If you have any questions relating to the MyScan service or would like to check if you can use Slough MyScan
        for your claim, please contact Slough Borough Council.</p>

      <p>You can contact Slough Borough Council on:</p>

      <p><strong>01753 475111</strong></p>

      <h2>Normal Opening Hours</h2>
      <p>
        Monday – 9am to 5pm<br/>
        Tuesday – 9am to 5pm<br/>
        Wednesday – 10am to 5pm<br/>
        Thursday – 9am to 5pm<br/>
        Friday – 9am to 4.30pm<br/>
      </p>
    </React.Fragment>
  );
}
